import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { ROUTES } from '../constants';
import { getMyAccountStaff } from 'Containers/Settings/store/selectors';
import { useSelector } from 'react-redux';
import { SUBSECTIONS } from 'Containers/Settings/containers/AccountsManager/constants';
import { isPathAllowed } from 'utils/staffPermissions';
import { loadHubSpotWidget, suppressHubSpotChat } from 'utils/hubspotChat';
import { PREMIUM_UPGRADE_PATH } from 'utils/premiumUpgradePath';

export const PrivateRoute = ({ component: RouteComponent, isAuthenticated }) => {
  const location = useLocation();
  const myAccount = useSelector(getMyAccountStaff());

  useEffect(() => {
    const pathname = location.pathname || '';
    const isScheduler = pathname.includes('/scheduler');
    const isSupport = pathname.includes('/support');

    if (isScheduler) {
      return suppressHubSpotChat();
    }

    if (isSupport) {
      loadHubSpotWidget();
    }

    return undefined;
  }, [location.pathname]);

  if (localStorage.getItem('staff') && myAccount.permessi?.length) {
    const pathname = location.pathname || '';
    const isPremiumLanding =
      pathname === PREMIUM_UPGRADE_PATH || pathname.startsWith(`${PREMIUM_UPGRADE_PATH}/`);
    if (!isPremiumLanding) {
      let allowed = myAccount.permessi.map((perm) => {
        let sub = SUBSECTIONS.find((s) => s.id === perm.sezione);
        return sub?.link || '';
      });
      if (!isPathAllowed(pathname, allowed)) {
        return <Navigate to={allowed[0]} state={{ from: location }} />;
      }
    }
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.SIGN_IN} state={{ from: location }} />;
  }

  return <RouteComponent />;
};
